import { Injectable, OnDestroy } from '@angular/core';
import { BreakpointService } from './breakpoint/breakpoint.service';

@Injectable({
  providedIn: 'root'
})
export class ResponsiveService implements OnDestroy {
  private device: 'large' | 'medium' | 'small' = 'large';
  private isPortrait: boolean = false;
  private deviceStyleClass:string = '';

  constructor(private breakpointService: BreakpointService) {

  } async initialize() {
    this.breakpointService.registerChannelChange(this);
    this.breakpointService.registerOrientationChange(this);
  }
  ngOnDestroy(): void {
    this.breakpointService.unregisterChannelChange(this);
    this.breakpointService.unregisterOrientationChange(this);
  }
  notifyScreenResize() {
    this.device = (this.breakpointService.useMobileStyle) ? 'small' : (this.breakpointService.useTabletStyle) ? 'medium' : 'large';
    this.applyChannelToRootDOM(this.device);
  }

  notifyOrientationChange(isPortrait: boolean) {
    this.isPortrait = isPortrait;
    this.applyOrientationToRootDOM();
  }
  applyChannelToRootDOM(channel:string){
    let htmlEl:any = document.getElementsByTagName('html')[0];
    let newStyleClassName:string = this.device + '-device';
    try{
      htmlEl.classList.remove(this.deviceStyleClass + '-device').add(newStyleClassName);
    }catch(error){
      console.log('default style class name remove error!');
      htmlEl.classList.add(newStyleClassName);
    }
    this.deviceStyleClass = this.device;
  }

  applyOrientationToRootDOM(){
    let htmlEl:any = document.getElementsByTagName('html')[0];
    try{
      if(this.isPortrait){
        htmlEl.classList.add('portrait-oriendation');
      } else {
        htmlEl.classList.remove('portrait-oriendation');
      }
    } catch(error){
      console.log('default style class name remove error!');
    }
  }
  isDesktop():boolean{
    return this.device == 'large';
  }
  isTablet():boolean{
    return this.device == 'medium';
  }
  isMobile():boolean{
    return this.device == 'small';
  }
  isPortraitOrientation():boolean{
    return this.isPortrait;
  }
  isHybrid():boolean{
    return (window['cordova']) ? true : false;
  }

}

